import { forwardRef, InputHTMLAttributes } from 'react';

import cx from 'classnames';

type QuestionFormInputProps = InputHTMLAttributes<HTMLInputElement>;

export default forwardRef<HTMLInputElement, QuestionFormInputProps>(
  function QuestionFormInput({ className, ...props }, ref) {
    return (
      <input
        ref={ref}
        {...props}
        className={cx(
          className,
          'appearance-none border border-blue-20 w-full py-2 px-3 text-grey-80 leading-tight focus:outline-none focus:shadow-outline',
        )}
      />
    );
  },
);
